<template>
  <el-container class="downCenter">
    <header>
      下载中心
      <div class="backToLogin" @click="backLogin">返回上级</div>
    </header>
    <div class="content">
      <div class="tabs-content">
        <h-button
          size="large"
          v-for="item in downData"
          :key="item.id"
          @click="tabsClick(item.id)"
          :class="{ activeStyle: item.id == activeNum }"
          >{{ item.tabsName }}</h-button
        >
      </div>
      <div class="info-content">
        <el-card v-for="it in downData[activeNum - 1].tabsContent" :key="it">
          <div class="title">
            <img
              v-if="it.type == 1"
              src="@/assets/images/login/liulanqi.png"
              alt=""
            />
            <img v-else src="@/assets/images/login/kehuduan.png" alt="" />
            <span>{{ it.name }}</span>
          </div>
          <div class="downLoad" @click="fileDownLoad(it.urlValue)">下载</div>
        </el-card>
      </div>
    </div>
  </el-container>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  onBeforeUpdate,
  onUpdated,
} from "vue";
import { useRouter } from "vue-router";
import util from "@util/js";
export default defineComponent({
  name: "downCenter",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      activeNum: 1,
      downData: window.PAGE_PATH.downCenter,
    });
    const refData = toRefs(data);
    onBeforeMount(() => {});
    onMounted(() => {});
    onBeforeUpdate(() => {});
    onUpdated(() => {});
    const router = useRouter();
    const tabsClick = (val) => {
      data.activeNum = val;
    };
    const backLogin = () => {
      router.go(-1);
    };
    const fileDownLoad = (urlValue) => {
      util.downFile(urlValue);
    };

    return { ...refData, tabsClick, backLogin, fileDownLoad };
  },
});
</script>
<style lang="scss" scoped>
.downCenter {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  header {
    width: 100%;
    height: 64px;
    line-height: 64px;
    text-align: center;
    background-color: #333333;
    color: #ffffff;
    font-size: 24px;
    .backToLogin {
      position: absolute;
      top: 0;
      right: 0px;
      color: #ffffff;
      outline: 0;
      font-size: 20px;
      height: 64px;
      line-height: 64px;
      padding: 0 40px 0 41px;
      text-decoration: none;
      cursor: pointer;
      z-index: 10;
    }
    .backToLogin:hover {
      background-color: #afa7a7;
    }
  }
  .content {
    width: 100%;
    margin-top: 50px;
    @include flex-col-c-c;
    .activeStyle {
      background-color: #1890ff;
      color: #fff;
    }
    .info-content {
      display: flex;
      margin-top: 40px;
      .el-card {
        box-sizing: border-box;
        border: 1px solid #ebedf0;
        height: 200px;
        width: 380px;
        margin: 15px 30px 15px 0;
        padding: 8px;
        position: relative;
        &:hover {
          border: 1px solid #1890ff;
        }
        .title {
          display: flex;
          img {
            width: 80px;
            height: 80px;
            margin-right: 12px;
          }
          span {
            line-height: 24px;
            font-size: 16px;
            font-weight: bold;
            overflow: hidden;
            padding-top: 12px;
            color: #1890ff;
          }
        }
        .downLoad {
          position: absolute;
          background-color: #1890ff;
          right: 20px;
          bottom: 20px;
          color: #fff;
          width: 44px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
